// extracted by mini-css-extract-plugin
export default {"container":"DailyQuote_container__okh8h","quoteText":"DailyQuote_quoteText__xmIYR"};